import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { Result } from '../Result';
import type { IMultiplePropagationConstraint } from '../../../stores/model/metamodel/multiple_propagation_constraint';

/**
 * Check if the multiple propagation constraint conflicts with another constraint.
 */
class MPCConflictCheck extends Check<IMultiplePropagationConstraint> {
  static description = 'Check for conflicting multiple propagation constraints';

  check(): Report {
    this.report = new Report();

    const mpc = this.element;

    for (const other of mpc.objectType.multiplePropagationConstraints) {
      if (mpc !== other) {
        if (mpc.conflicts(other)) {
          this.report.addMessage(
            MessageType.ERROR,
            `Conflicts with ${other.displayString}.`,
            this,
            this.element
          );
        }
      }
    }

    if (this.report.result === Result.NO_RESULT) {
      this.report.addMessage(
        MessageType.INFORMATION,
        `No conflicting multiple propagation constraints found.`,
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default MPCConflictCheck;
